module.exports = __webpack_public_path__ + "static/img/service-eva-ac.e8e29ccf.png";